import { useEffect, useState } from 'react';
import { getPlaceholderCatalog } from '../../../../services/emailPlaceholderService';

let cache = null;

// Fetches (and caches for the session) the canonical system placeholder catalog
// so the composer's autocomplete/highlighting never drifts from backend validation.
export default function usePlaceholderCatalog() {
    const [catalog, setCatalog] = useState(cache || []);
    const [loading, setLoading] = useState(!cache);

    useEffect(() => {
        if (cache) return;
        let active = true;
        getPlaceholderCatalog()
            .then((data) => {
                if (!active) return;
                cache = Array.isArray(data) ? data : (data?.placeholders || []);
                setCatalog(cache);
            })
            .catch(() => {
                if (active) setCatalog([]);
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => {
            active = false;
        };
    }, []);

    return { catalog, loading, tokens: catalog.map((entry) => entry.token || entry) };
}
